<template>
  <div class="language-banner-atom" ref="dropdownContainer">
    <div class="language-banner-atom__dropdown" @click="toggleDropdown">
      {{ selectedLanguageName }}
      <i class="bi bi-arrow-down-short arrow-icon" :class="{ 'arrow-icon_open': isDropdownOpen }"></i>
      <div v-if="isDropdownOpen" class="dropdown-options">
        <div v-for="language in languages" :key="language.code" @click="selectLanguage(language)" :class="{ selected: selectedLanguage === language.code }" class="dropdown-option">
          {{ language.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const defaultLanguage = 'sv';
    return {
      isDropdownOpen: false,
      selectedLanguage: localStorage.getItem('selectedLanguage') || defaultLanguage,
      languages: [
        { code: 'en', name: 'English' },
        { code: 'sv', name: 'Svenska' },
      ],
    };
  },
  computed: {
    selectedLanguageName() {
      return this.languages.find((language) => language.code === this.selectedLanguage).name;
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLanguage(language) {
      this.selectedLanguage = language.code;
      this.isDropdownOpen = false;
      localStorage.setItem('selectedLanguage', language.code);
      this.$emit('languageChange', language.code);
      location.reload();
    },
    handleOutsideClick(event) {
      if (!this.$refs.dropdownContainer.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
};
</script>

<style scoped>
.language-banner-atom {
  position: relative;
  height: 40px;
  background-color: black;
}

.language-banner-atom__dropdown {
  float: right;
  margin-right: 40px;
  margin-top: 5px;
  display: flex;
  gap: 5px;
}

.arrow-icon {
  display: flex;
  transition: transform 0.2s;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}

.arrow-icon_open {
  transform: rotate(180deg);
}

.dropdown-options {
  position: absolute;
  top: 40px;
  background-color: black;
  color: white;
  padding: 5px;
  z-index: 9999;
}

.dropdown-option {
  padding: 10px;
  cursor: pointer;
}
.dropdown-option:hover {
  background-color: gray;
}
</style>
